import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ems-dental-spa',
  templateUrl: './ems-dental-spa.component.html',
  styleUrls: ['./ems-dental-spa.component.scss']
})
export class EmsDentalSpaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
